/*
 * Shared Embla loader (singleton).
 *
 * Fetches and evaluates the self-hosted Embla library at most once per page,
 * no matter how many carousels (<oilogic-hero-carousel>, <oilogic-carousel>, …)
 * request it. The in-flight/resolved promise is memoised on window, so repeat
 * calls never re-inject the script or re-run the library.
 *
 * Usage:  window.oilogicEmbla(url) -> Promise<EmblaCarousel>
 */
(function () {
  if (window.oilogicEmbla) return;

  window.oilogicEmbla = function (url) {
    if (typeof window.EmblaCarousel === 'function') {
      return Promise.resolve(window.EmblaCarousel);
    }
    if (!window.__oilogicEmblaPromise) {
      window.__oilogicEmblaPromise = new Promise(function (resolve, reject) {
        if (!url) {
          reject(new Error('oilogicEmbla: missing embla url'));
          return;
        }
        var script = document.createElement('script');
        script.src = url;
        script.onload = function () { resolve(window.EmblaCarousel); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return window.__oilogicEmblaPromise;
  };
})();
